module.exports = {
    defaultLanguage: 'es',
    scssVariables: './src/styles/fypf2022',
    profileColor: {saturation: 90, brightness: 65},
    favicon: 'fypffavicon.ico',
    defaultPassword: 'fypf2022'
}

